var _defs, _rect, _circle, _circle2, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _rect7, _rect8, _rect9, _circle3, _rect0, _rect1, _rect10, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankingHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 760,
    height: 520,
    viewBox: "0 0 760 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 60,
    y1: 40,
    x2: 700,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168AAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 380,
    y1: 130,
    x2: 380,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F5FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "roof",
    x1: 380,
    y1: 80,
    x2: 380,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A300"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 720,
    height: 480,
    rx: 30,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 115,
    r: 70,
    fill: "#FFFFFF",
    fillOpacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 425,
    r: 95,
    fill: "#FFFFFF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165 165L380 75L595 165V185H165V165Z",
    fill: "url(#roof)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185 200H575V420H185V200Z",
    fill: "url(#glass)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 230,
    width: 55,
    height: 150,
    rx: 9,
    fill: "#0A2A52",
    fillOpacity: 0.78
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 230,
    width: 55,
    height: 150,
    rx: 9,
    fill: "#0A2A52",
    fillOpacity: 0.78
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 230,
    width: 55,
    height: 150,
    rx: 9,
    fill: "#0A2A52",
    fillOpacity: 0.78
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 230,
    width: 55,
    height: 150,
    rx: 9,
    fill: "#0A2A52",
    fillOpacity: 0.78
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 420,
    width: 420,
    height: 20,
    rx: 8,
    fill: "#06203E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380 123C398.778 123 414 138.222 414 157H346C346 138.222 361.222 123 380 123Z",
    fill: "#06203E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 305,
    width: 115,
    height: 70,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.15
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 320,
    width: 52,
    height: 12,
    rx: 6,
    fill: "#FFFFFF",
    fillOpacity: 0.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 340,
    width: 86,
    height: 10,
    rx: 5,
    fill: "#FFFFFF",
    fillOpacity: 0.42
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 325,
    r: 11,
    fill: "#FFD166"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 100,
    width: 130,
    height: 82,
    rx: 16,
    fill: "#FFFFFF",
    fillOpacity: 0.15
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 120,
    width: 58,
    height: 11,
    rx: 5.5,
    fill: "#FFFFFF",
    fillOpacity: 0.75
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 139,
    width: 96,
    height: 9,
    rx: 4.5,
    fill: "#FFFFFF",
    fillOpacity: 0.42
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M606 133L617 145L640 121",
    stroke: "#FFD166",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingHero);
export default __webpack_public_path__ + "static/media/banking-hero.c8f58e76fb878726baa0cbf85a65599a.svg";
export { ForwardRef as ReactComponent };